export const STARTING_DATE_RANGE: number = 2;
